export default __webpack_public_path__ + "static/media/be.088520d0.svg";